import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const ImageBackdrop = styled('span')(({ theme }) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.65, // Increased initial opacity from 0.4 to 0.65
    transition: theme.transitions.create('opacity'),
    backgroundImage: 'linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.7))', // Added gradient overlay
}));

const ImageButton = styled(ButtonBase)(({ theme }) => ({
    position: 'relative',
    height: 300,
    borderRadius: theme.shape.borderRadius * 2,
    border: '2px solid #e0e0e0',
    overflow: 'hidden',
    margin: theme.spacing(2),
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',

    [theme.breakpoints.down('md')]: {
        width: '90% !important',
        height: 300,
        margin: theme.spacing(2, 0),
    },

    '&:hover, &.Mui-focusVisible': {
        zIndex: 1,
        transform: 'translateY(-4px)',
        boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
        '& .MuiImageBackdrop-root': {
            opacity: 0.4, // Lighter on hover
            backgroundImage: 'linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.4))', // Lighter gradient on hover
        },
        '& .MuiImageMarked-root': {
            opacity: 0,
        },
        '& .MuiTypography-root': {
            border: '2px solid currentColor',
        },
    },
}));

const ImageSrc = styled('span')({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%',
});

const Image = styled('span')(({ theme }) => ({
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    color: theme.palette.common.white,
}));

const ImageMarked = styled('span')(({ theme }) => ({
    height: 4,
    width: 40,
    backgroundColor: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 20px)',
    transition: theme.transitions.create('opacity'),
}));


export default function ProjectSelection() {
    const navigate = useNavigate();
    const location = useLocation();
    const userData = location.state?.userData;
    const createProjectsArray = (userData) => {
        let projectsArray = [];
        userData?.projects?.map((project, index) => {
            let projectItem = {
                url: `/assets/TempImage${index + 1}.jpg`,
                title: project.name,
                label: project.label,
                path: `/${project.name}/dashboard`,
                project: project.name,
                width: 450,
            }
            projectsArray.push(projectItem);
        });
        return projectsArray;
    }

    let projectsArray = createProjectsArray(userData);
    const getUserProjects = async () => {
        let projectNames = userData?.projects?.map(project => project.name);
        return projectNames;
    };

    function getProjectPages(projectName) {
        const project = userData?.projects.find(proj => proj.name === projectName);

        if (!project) return []; // Eğer proje bulunamazsa boş array döndür

        // Tüm rollerin içindeki pages dizilerini toplayıp düzleştiriyoruz
        const pages = Object.values(project.roles)
            .flatMap(role => role.pages);

        return [...new Set(pages)]; // Tekrarlayanları kaldırmak için Set kullanıyoruz
    }
    /* const getUserPages = async () => {
        let pages = userData?.projects?.map(project => project.roles.admin.pages);
        let pagesFlat = pages.flat();
        return pagesFlat;
    } */

    const getUserRoles = async () => {
        const all_roles_keys = userData?.projects?.map(project => Object.keys(project.roles));
        const all_roles_keys_flat = all_roles_keys.flat();
        const all_roles_keys_flat_lower = all_roles_keys_flat.map(role => role.toLowerCase());
        return all_roles_keys_flat_lower;
    }
    const goToProject = async (project) => {
        let projectNames = await getUserProjects();
        let allowedPages = getProjectPages(project.project);
        const all_roles_keys_flat_lower = await getUserRoles();


        
        localStorage.setItem('selectedProject', project.project);
        localStorage.setItem('allowedProjects', JSON.stringify(projectNames));
        localStorage.setItem('all_roles', JSON.stringify(all_roles_keys_flat_lower));
        localStorage.setItem('allowedPages', JSON.stringify(allowedPages));

        navigate(`/${project.project}/dashboard`);
    }
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            background: "linear-gradient(135deg, #f5f7fa 0%, #f5f7fa    100%)",

            //background: 'linear-gradient(90deg, rgba(31,149,98,0.1) 90%,rgba(31,149,98,0.2)100%)',
            //backgroundColor: 'red',
            pb: 4 // Add padding at bottom
        }}>
            <Box
                sx={{
                    position: 'absolute',
                    bottom: 16,  // Adjust these values
                    right: 16,   // to position as needed
                    zIndex: 1,   // Ensure it stays above other content
                }}
            >
                <img
                    src="/assets/entras.svg"
                    alt="Logo"
                    width={250}
                    height={250}
                    style={{
                        opacity: 0.1,
                        cursor: 'pointer',
                    }}
                />
            </Box>
            <Typography
                variant="h3"
                component="h1"
                sx={{
                    textAlign: 'center',
                    p: 6, // Increased vertical padding
                    color: 'text.primary',
                    fontWeight: 'bold'
                }}
            >
                Select Project
            </Typography>
            <Box sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center', // Center horizontally
                alignItems: 'center', // Center vertically
                gap: 4, // Gap between items
                width: '100%',
                maxWidth: 1400, // Increased max width
                mx: 'auto',
                px: 3,
            }}>

                {projectsArray?.map((project) => (
                    <ImageButton
                        focusRipple
                        key={project}
                        onClick={() => goToProject(project)}
                        style={{
                            width: project.width,
                            backgroundColor:"#1F956260"
                        }}
                    >
                        {/*                         <ImageSrc style={{ backgroundImage: `url(${project.url})` }} />
 */}


                        <ImageBackdrop className="MuiImageBackdrop-root" />
                        <Image>
                            <Typography
                                component="span"
                                variant="h4"
                                color="inherit"
                                sx={{
                                    position: 'relative',
                                    p: 4,
                                    pt: 2,
                                    pb: (theme) => `calc(${theme.spacing(2)} + 6px)`,
                                    fontWeight: 'bold',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.4)', // Text shadow for better readability
                                    width: 200,
                                    textTransform: 'capitalize',
                                }}
                            >
                                {project.label}
                                <ImageMarked className="MuiImageMarked-root" />
                            </Typography>

                        </Image>
                    </ImageButton>
                ))}
            </Box>
        </Box>
    );
}